import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import get from 'lodash/get';
import { useTranslation } from '../../src/i18n';
import opera from '../../public/images/opera.jpg';
import H2 from '../H2';
import ParseHtml from '../ParseHtml';
import { colors } from '../../constants/styleConstants';
import { selectHomeNumbers } from '../../containers/Home/selectors';

const useStyles = makeStyles(theme => ({
  searchBg: {
    height: 'auto',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    width: '100%',
    textAlign: 'center',
    padding: '65px 100px 10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '18px 16px',
    },
  },
  mainHeading: {
    padding: '0 50px',
    marginBottom: 10,
    '& *': {
      color: colors.white,
      lineHeight: 1.45,
      fontSize: 40,
      [theme.breakpoints.down('sm')]: {
        fontSize: 20,
      },
    },
  },
  stats: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  statItem: {
    margin: '10px 22px',
    color: colors.white,
    fontWeight: 'bold',
    marginRight: 3,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      margin: 10,
    },
  },
  statInfo: {
    fontWeight: 'lighter',
    fontSize: 10,
    color: colors.white,
    marginLeft: '0.5em',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
}));

const SearchBg = ({ commonOBNumbers }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const staticInfo = [
    { number: get(commonOBNumbers, 'performances'), info: 'operabase.general.m_PERF' },
    { number: get(commonOBNumbers, 'companies'), info: 'operabase.general.m_OPCOS' },
    { number: get(commonOBNumbers, 'festivals'), info: 'operabase.general.m_FESTIVALS' },
    { number: get(commonOBNumbers, 'artists'), info: 'operabase.general.m_ARTISTS' },
    { number: get(commonOBNumbers, 'managers'), info: 'operabase.general.m_MANAGERS' },
  ];

  const staticInfoAvailable = !!Object.values(commonOBNumbers).filter(Boolean).length;

  return (
    <div className={classes.searchBg} style={{ background: `url(${opera})` }}>
      <H2 className={classes.mainHeading}>
        <ParseHtml>{`<span>${t('operabase.general.m_HOMETOP1')}</span>`}</ParseHtml>
      </H2>
      {staticInfoAvailable && (
        <div className={classes.stats}>
          {staticInfo.map(item => (
            <div className={classes.statItem} key={item.info}>
              {item.number && item.number.toLocaleString()} <span className={classes.statInfo}>{t(item.info)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

SearchBg.propTypes = {
  commonOBNumbers: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  commonOBNumbers: selectHomeNumbers(),
});

const withConnect = connect(mapStateToProps, null);

export default withConnect(SearchBg);
